import {
  SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY,
  SUPER_ADMIN_SET_COMPANIES,
  SUPER_ADMIN_REMOVE_USER_TO_BRAND,
  SUPER_ADMIN_ADD_USER_TO_BRAND,
  SUPER_ADMIN_SET_NEW_COMPANY_ADMIN
} from '../constants/action-types/super-admin';

export const superAdminSetCompanies = companies => {
  return {
    type: SUPER_ADMIN_SET_COMPANIES,
    payload: companies,
  };
};

export const superAdminSetNewAdmin = newAdmin => {
  return {
    type: SUPER_ADMIN_SET_NEW_COMPANY_ADMIN,
    payload: newAdmin,
  };
};

export const superAdminSetNewDateForCompany = newCompany => {
  return {
    type: SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY,
    payload: newCompany,
  };
};

export const superAdminAddUserToBrand = data => {
  return {
    type: SUPER_ADMIN_ADD_USER_TO_BRAND,
    payload: data,
  };
};

export const superAdminRemoveUserFromBrand = data => {
  return {
    type: SUPER_ADMIN_REMOVE_USER_TO_BRAND,
    payload: data,
  };
};
